import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { CategoryTreeContainer } from '../../state/categories';
import { CategoryCard } from '../CategoryCard/CategoryCard';
import { Redirect, useParams } from 'react-router-dom';
import { Layout } from '../Layout/Layout';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../../i18n/i18n';
import { useSession } from '../../state/session';
import { NotFoundPage } from './NotFoundPage';
import { useConfig } from '../../config';

export const SuperCategoryPage = (): JSX.Element => {
	const categories = CategoryTreeContainer.useContainer();
	const { user } = useSession();
	const { perma } = useParams<UrlParams>();
	const subtree = categories.tree.children.find((e) => e.perma === perma);
	const t = useTranslation().category;
	const { routes } = useTranslation();
	const { domain } = useConfig();
	const absolutePath = `https://${domain}/${perma}`;

	if (user?.specialsOnly) return <Redirect to={routes.specialPrices} />;
	if (!subtree) return <NotFoundPage />;

	return (
		<Main>
			<Helmet>
				<title>{subtree.name + t.titleShortSuffix}</title>
				<link rel="canonical" href={absolutePath} />
			</Helmet>
			<Layout type="columns">
				{subtree.children
					.sort(function (a, b) {
						return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
					})
					.map((e) => (
						<CategoryCard key={e.id} category={e} />
					))}
			</Layout>
		</Main>
	);
};

export type UrlParams = { perma: string };

export const superCategoryRouting: Routing = {
	path(_urls) {
		return '/:perma(c/kontor\\-papper|c/it\\-elektronik|c/stad\\-rengoring|c/sjukvard\\-omsorg|c/skola\\-forskola|c/mobler\\-inredning|c/kontor\\-papir|c/kjokken\\-drikke|c/skole\\-hobby|c/tork\\-renhold|c/pleie\\-verneutstyr|c/elektronik|c/kokken\\-drikke|c/rengoring|c/vaernemidler\\-toj|c/kontorindretning|c/rengoring\\-aftorring|c/kantoor\\-papier|c/schoonmaak\\-hygiene|c/keuken\\-dranken|c/school\\-hobby|c/kantoorinrichting|c/bescherming\\-verzorging|c/it\\-elektronica|fika\\-stad\\-till\\-fikat\\-c\\-5210000\\_5214200.html)';
	},
	component: SuperCategoryPage,
	requiresAuth: false,
	cacheMaxAge: 3600,
};
